<lib-suivi-demandes (onUpdateStatusEvent) = 'handleUpdateStatusEvent($event)' (onEmitUnreadNotificationsEvent)="handleEmitTotalElementEvent($event)"></lib-suivi-demandes>
